import React, {useState} from "react";
import { Modal, ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import './css/main.css';
import SearchBox from "./SearchBox";
import LoaderSpinner from "./LoaderSpinner";
import { connect } from "react-redux";
function Content(props) {
    const [viewCompare, setViewCompare] = useState(false)
    const viewcompareContent = (opened) =>{
        setViewCompare(opened)
    }
    return (
        <div className="scrollBarStyle">

            
                    {props.actionData.isLoaderActive && <LoaderSpinner />}
                    {!viewCompare &&
                        // <ModalTitle>
                            <h2 className="modalHeading">Search to compare Fios TV packages</h2>

                        // </ModalTitle>
                    }
                    {/* <ModalBody> */}
                        <div className="modalContent">
                            <SearchBox viewcompareContent={viewcompareContent}/>
                        </div>
                    {/* </ModalBody> */}
                </div>
            
    )
}
const mapStateToProps = (state) => {
    return {
        actionData: state.channelReducer.actionData
    }
}

export default React.memo(connect(mapStateToProps)(Content));